import { offsetLimitPagination } from "@apollo/client/utilities";
export const keyMappings: any = {
  Query: {
    fields: {
      news: offsetLimitPagination(["queryString", "locale"]),
      publicareOrders: offsetLimitPagination(["queryString", "status", "sort"]),
      academyModel: offsetLimitPagination(["locale", "filter"]),
    },
  },
  academyModel: offsetLimitPagination(["locale", "filter"]),
  PublicareClient: {
    fields: {
      orders: offsetLimitPagination([
        "clientId",
        "queryString",
        "status",
        "sort",
      ]),
    },
  },
  ProductSearchResult: {
    fields: {
      products: offsetLimitPagination(),
    },
  },
};

export const keyFields: any = {
  keyFields: (result: any) => {
    if (result?._id && result?.__typename) {
      return `${result?.__typename}:${result?._id}`;
    }
    if (result?.id && result?.__typename) {
      return `${result.__typename}:${result.id}`;
    }
    return null;
  },
};

const typePolicies = { ...keyMappings, ...keyFields };

export default typePolicies;
